import { useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Menu, MenuItem } from "@mui/material";
import styles from "./Avatar.module.css";
import GlobalIcon from "../GlobalIcon/GlobalIcon";

function Avatar() {
  const { auth, logout } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Get user initials for avatar fallback
  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Get role display name
  const getRoleDisplay = (role) => {
    if (!role) return "User";
    return role.charAt(0) + role.slice(1).toLowerCase();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
  };

  return (
    <div className={styles["avatar-container"]}>
      <div
        className={styles["avatar-wrapper"]}
        onClick={handleClick}
        aria-controls={open ? "avatar-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <div className={styles["avatar-image"]}>
          {auth.user?.profile_picture ? (
            <img
              src={auth.user.profile_picture}
              alt={auth.user?.name || "User"}
            />
          ) : (
            <div className={styles["avatar-initials"]}>
              {getInitials(auth.user?.name || "User")}
            </div>
          )}
        </div>
        <div className={styles["avatar-info"]}>
          <div className={styles["avatar-name"]}>
            {auth.user?.name || "User"}
          </div>
          <div className={styles["avatar-role"]}>
            {getRoleDisplay(auth.user?.role)}
          </div>
        </div>
        <div className={styles["avatar-dropdown-icon"]}>
          <GlobalIcon
            iconName="DropdownArrow"
            className={`${styles["dropdown-arrow"]} ${
              open ? styles["dropdown-arrow-open"] : ""
            }`}
            aria-label="Dropdown"
          />
        </div>
      </div>

      <Menu
        id="avatar-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          className: styles["avatar-menu-paper"],
        }}
      >
        <MenuItem onClick={handleLogout} className={styles["menu-item"]}>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}

export default Avatar;

